import React from 'react';
import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import {withStyles} from '@material-ui/core/styles';
import {Body} from '../../../components/Typography';
import {
  FlatButton,
  PrimaryButton,
  FlatButtonRow,
} from '../../../components/Buttons';

const Wrapper = styled.div`
  display: grid;
  grid-template-rows: 1fr auto;
  grid-gap: 10px;
  align-items: center;
  height: 130px;
  padding: 20px 40px;
  text-align: center;
  min-width: 350px;
  @media (max-width: 786px) {
    min-width: 280px;
  }
`;

const PrimaryButtonWrapper = styled(PrimaryButton)`
  @media (max-width: 768px) {
    width: inherit;
  }
`;

const styles = () => ({
  paper: {
    margin: 0,
  },
});

const ConfirmDelete = ({
  confirmDeletePaymentMethodIsVisible,
  handleCancelDeletePaymentMethod,
  handleDeletePaymentMethod,
  requestingDeletePaymentMethod,
  classes,
}) => {
  return (
    <Dialog
      open={confirmDeletePaymentMethodIsVisible}
      onClose={handleCancelDeletePaymentMethod}
      fullWidth={typeof window !== 'undefined' && window.innerWidth < 786}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      PaperProps={{classes: {root: classes.paper}}}
      aria-labelledby="confirm-delete-payment-method"
    >
      <Wrapper>
        <Body>Are you sure you want to delete this card?</Body>
        <FlatButtonRow>
          <FlatButton
            id="PaymentMethods-DeletePaymentMethod"
            onClick={handleCancelDeletePaymentMethod}
            disabled={requestingDeletePaymentMethod}
          >
            Cancel
          </FlatButton>
          <PrimaryButtonWrapper
            small
            onClick={handleDeletePaymentMethod}
            disabled={requestingDeletePaymentMethod}
            showLoading={requestingDeletePaymentMethod}
          >
            Delete
          </PrimaryButtonWrapper>
        </FlatButtonRow>
      </Wrapper>
    </Dialog>
  );
};

export default withStyles(styles)(ConfirmDelete);
